import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { Helmet } from 'react-helmet';
import Wrapper from '../layouts/Wrapper';
import OurServices from '../components/home/OurServices';
import OurTeam from '../components/home/OurTeam';
import OurPartners from '../components/home/OurPartners';
import Reviews from '../components/home/Reviews';
import BannerSlider from '../components/home/BannerSlider';
import OurMerits from '../components/home/OurMerits';
import Faq from '../components/home/Faq';
import Question from '../components/home/Question';
import { getHomePage } from '../store/actions/homePage';
import Spinner from '../components/Spinner';
import { getFaqPage } from '../store/actions/faqPage';
import { getPartnersPage } from '../store/actions/partnersPage';
import { getFAQSchema } from '../utils/schema';

function Home() {
  const dispatch = useDispatch();
  const lang = Cookies.get('i18next') || 'en';
  const { data, loading } = useSelector((state) => state.homePage);
  const { data: faqData, loading: faqLoading } = useSelector((state) => state.faqPage);
  const { loading: loadingPartners, data: partners } = useSelector((state) => state.partnersPage);
  useEffect(() => {
    dispatch(getHomePage());
    dispatch(getFaqPage());
    dispatch(getPartnersPage());
  }, []);
  const faqSchema = getFAQSchema(faqData?.frequentlyAskedQuestions?.data, lang);
  return (
    <Wrapper loading={loading}>
      {/* Schema 5: FAQPage, built from the accordion rendered further down.
          Schema 1 (Organization) and Schema 2 (WebSite) are static and inlined
          in public/index.html, so they are in the HTML source of every
          response instead of appearing only after React mounts. */}
      {faqSchema && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(faqSchema)}
          </script>
        </Helmet>
      )}
      {(!loading && !faqLoading && !loadingPartners) ? (
        <>
          <BannerSlider data={data.sliders} />
          <OurMerits data={data.homePageData.data} />
          <OurServices data={data.homePageData} />
          <OurTeam data={data.all_staff} />
          <OurPartners data={partners.partners} />
          <Reviews data={data.reviews} />
          <Faq data={faqData.frequentlyAskedQuestions} />
          <Question data={data.homePageData.data} />
        </>
      ) : <Spinner width={100} height={100} />}
    </Wrapper>
  );
}

export default Home;
